import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "../auth/auth.service";
import {EventsService} from "../../bo/events/events.service";

@Injectable()
export class EventGuard implements CanActivate {
  id:number;
  event:Event;

  constructor(private authService: AuthService,private route :ActivatedRoute,private eventservice:EventsService){

    this.route.params.subscribe(params => {
    //  eventservice.event(params['id']).then(res => this.event = res);
      this.id = +params['id'];
    console.log('eventguard'+params['id'])
    })

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    var user = this.authService.getUser();
    return true;
  }
}
